<template>
  <div class="ly-input-wrap">
    <!-- 输入框区域 -->
    <div class="input-container" @click="handleContainerClick">
      <!-- 多选标签 -->
      <template v-if="multiple">
        <div class="tag-list">
          <Tag
            v-for="tag in selectedList"
            :key="tag.value"
            closable
            @on-close="removeTag(tag)"
          >
            {{ tag.label }}
          </Tag>
        </div>
      </template>

      <!-- 输入框 -->
      <Input
        v-model="inputVal"
        clearable
        :loading="loading"
        :placeholder="multiple ? '请选择/搜索' : '请输入'"
        @on-change="handleInput"
        @on-blur="onBlur"
        @on-focus="onFocus"
        class="search-input"
        ref="inputRef"
      />
    </div>

    <!-- 下拉列表：mousedown 阻止 blur 触发关闭 -->
    <ul
      v-if="showDrop && list.length"
      class="ly-drop"
      @mousedown.prevent="isClickingDrop = true"
      @mouseup="isClickingDrop = false"
    >
      <li
        v-for="item in list"
        :key="item.value"
        class="ly-drop-item"
        :class="{ active: isSelected(item) }"
        @click="selectItem(item)"
      >
        <span>{{ item.label }}</span>
        <span style="margin-left: auto; color: #999">{{ item.remark }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Array],
    data: Function,
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVal: "",
      list: [],
      loading: false,
      showDrop: false,
      timer: null,
      selectedList: [], // 内部依然存对象（展示用）
      isClickingDrop: false
    };
  },
  watch: {
    value: {
      handler(val) {
        if (this.multiple) {
          // 父组件传来的是 [1,2,3]
          const valueArr = Array.isArray(val) ? val : [];
          // 转成内部展示用的对象数组
          this.selectedList = this.list.filter(item =>
            valueArr.includes(item.value)
          );
        } else {
          this.inputVal = val || "";
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleContainerClick() {
      this.$nextTick(() => {
        if (this.$refs.inputRef) {
          this.$refs.inputRef.focus();
        }
      });
    },

    onBlur() {
      if (this.multiple && this.isClickingDrop) {
        return;
      }
      setTimeout(() => {
        this.showDrop = false;
      }, 200);
    },

    onFocus() {
      this.showDrop = true;
      this.loadList();
    },

    handleInput() {
      clearTimeout(this.timer);
      if (!this.multiple) {
        this.$emit("input", this.inputVal);
      }
      this.timer = setTimeout(async () => {
        await this.loadList();
      }, 300);
    },

    async loadList() {
      if (typeof this.data !== "function") return;
      this.loading = true;
      try {
        let res = await this.data(this.inputVal);
        this.list = res || [];

        // 多选：每次加载列表后，重新映射选中值
        if (this.multiple) {
          const valueArr = Array.isArray(this.value) ? this.value : [];
          this.selectedList = this.list.filter(item =>
            valueArr.includes(item.value)
          );
        }

        this.showDrop = this.list.length > 0;
      } finally {
        this.loading = false;
      }
    },

    isSelected(item) {
      if (!this.multiple) return false;
      return this.selectedList.some(i => i.value === item.value);
    },

    selectItem(item) {
      if (this.multiple) {
        const exist = this.selectedList.some(i => i.value === item.value);
        let newSelectedList;
        if (exist) {
          newSelectedList = this.selectedList.filter(
            i => i.value !== item.value
          );
        } else {
          newSelectedList = [...this.selectedList, item];
        }

        this.selectedList = newSelectedList;

        // 核心：只抛 value 数组 [1,2,3] 给父组件！
        const valueArr = newSelectedList.map(i => i.value);
        this.$emit("input", valueArr);
        this.$emit("row", newSelectedList);
        this.inputVal = "";
      } else {
        this.inputVal = item.label;
        this.$emit("input", item.label);
        this.$emit("row", item);
        this.showDrop = false;
      }
    },

    removeTag(item) {
      const newSelectedList = this.selectedList.filter(
        i => i.value !== item.value
      );
      this.selectedList = newSelectedList;

      // 核心：删除也只抛 value 数组
      const valueArr = newSelectedList.map(i => i.value);
      this.$emit("input", valueArr);
      this.$emit("row", newSelectedList);
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>

<style scoped>
.ly-input-wrap {
  position: relative;
}
.input-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 4px;
  min-height: 36px;
}
.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.search-input {
  flex: 1;
  min-width: 100px;
  border: none !important;
}
.ly-drop {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  z-index: 999;
  max-height: 200px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
}
.ly-drop-item {
  padding: 8px 12px;
  line-height: 1.4;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.ly-drop-item:hover {
  background: #f5f5f5;
}
.ly-drop-item.active {
  background: #e6f7ff;
  color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/lyInput.vue